module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Watch1-3770f1b6237e8830c7ffba72cb59a381.svg";